import { Suspense, useState } from 'react';

import { IconAngleRight } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { TopupInEligibleSVG } from '@svgComponents/TopupInEligibleSVG/TopupInEligibleSVG';
import { FormattedMessage } from 'react-intl';

import { useGetNotTopUpEligibleData } from './useGetNotTopUpEligibleData';
import HelpModal from '../../../navigation/helpModal/HelpModal';
import MainContentPending from '../../../pageStructure/mainContentPending';
import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const NotTopUpEligible = () => {
    return (
        <Suspense fallback={<MainContentPending />}>
            <NotTopUpEligibleContent />
        </Suspense>
    );
};

const NotTopUpEligibleContent = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { companyName } = useGetNotTopUpEligibleData();

    return (
        <>
            <DashboardCTA
                data-testid="not-top-up-eligible"
                icon={<TopupInEligibleSVG />}
                title={
                    <FormattedMessage
                        id="_.dashboard_widget.notTopupEligible.title"
                        defaultMessage="Sorry, you can’t request more funds at the moment"
                    />
                }
                description={
                    <>
                        <strong>{companyName}</strong>{' '}
                        <FormattedMessage
                            id="_.dashboard_widget.notTopupEligible.description"
                            defaultMessage="isn’t eligible for additional funding - feel free to give your account manager a call if you’d like to know more."
                        />
                    </>
                }
                cta={
                    <Button
                        variant="tertiary"
                        onClick={() => setIsModalOpen(true)}
                        className="flex-wrap p-0 text-s hover:!bg-transparent hover:underline"
                    >
                        <FormattedMessage
                            id="_.dashboard_widget.notTopupEligible.cta"
                            defaultMessage="Get in touch"
                        />
                        <IconAngleRight />
                    </Button>
                }
            />
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <HelpModal />
            </Modal>
        </>
    );
};
